import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import RichTextEditor from '../../../components/Editor/RichTextEditor';
import { IndesignTextFieldsConfig } from '../utils/indesignEditor/editableTextFields/getData';
import { HtmlTextFieldsConfig } from '../utils/htmlEditor/editableTextFields/getData';

const isPropInData = (prop: string, data: IndesignTextFieldsConfig | HtmlTextFieldsConfig): boolean => (
	prop in data ? data[prop] : undefined
);

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			type,
			editableTextFields,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	const { page, id, isEdited } = ownProps;
	const data = editableTextFields[page][id];
	const { width, height, content } = data;
	const isActive = id === activeItem.id;

	return {
		editorType: type,
		width,
		height,
		content,
		isActive,
		activeParentId: activeItem.parentId,
		isEditPanelDisplayed,
		shouldShowScrollbar: isActive || isEdited || !!isPropInData('isEditedFromBackoffice', data),
		selfScale: isPropInData('selfScale', data),
		transformStyle: isPropInData('transformStyle', data),
		parentId: isPropInData('parentId', data),
	};
};

export default connect(mapStateToProps)(RichTextEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/RichTextEditor/index.tsx